import { CircularProgress } from "@mui/material";
import styles from "./PageLoader.module.scss";

interface PageLoaderProps {
  label?: string;
}

export const PageLoader = ({ label = "Načítání..." }: PageLoaderProps) => {
  return (
    <div className={styles.wrapper}>
      <CircularProgress color="primary" size={48} thickness={4} />
      <span className={styles.label}>{label}</span>
    </div>
  );
};
